import { useState } from "react";

// context
import { useCurrentResultContext } from "../../services/context/current-result-context";
import { useAppContext } from "../../services/context/app-context";

// components
import { MapToolbar } from "../map/map-toolbar";
import { BuildingLayer } from "./building-layer";
import { PropertyLayer } from "./property-layer";
import { SidebarResults } from "./sidebar/sidebar-results";
import { SidebarResultsRight } from "./sidebar/sidebar-results-right";


export const Results = ({ projectId, propertyGeoData }) => {
  const { property } = useAppContext();
  const [selectedRunner, setSelectedRunner] = useState(null);
  const [selectedResult, setSelectedResult] = useState(null);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [displayDimensions, setDisplayDimensions] = useState(false);

  const [buildingGrids, setBuildingGrids] = useState({});
  const [showGrid, setShowGrid] = useState(false);

  const getSelectedGridIndex = (resultId, buildingId) =>
    buildingGrids?.[resultId]?.[buildingId] ?? 0;

  const setSelectedGridIndex = (resultId, buildingId, gridIndex) => {
    setBuildingGrids((prev) => ({
      ...prev,
      [resultId]: {
        ...prev[resultId],
        [buildingId]: gridIndex,
      },
    }));
  };

  const setSelectedResultHandler = (result) => {
    setSelectedResult(result);
    setSelectedBuilding(null);
    setShowGrid(false);
    setBuildingGrids({});
  };

  const setSelectedRunnerHandler = (runner) => {
    setSelectedRunner(runner);
    setSelectedBuilding(null);
    setShowGrid(false);
    setBuildingGrids({});

    // If runner is cleared, also clear the selected result
    if (runner === null) {
      setSelectedResult(null);
    }
  };

  return (
    <>
      <MapToolbar
        selectedRunner={selectedRunner}
        isSiteSettings={false}
        displayDimensions={displayDimensions}
        setDisplayDimensions={setDisplayDimensions}
        property={selectedRunner?.PropertyData || property || null}
        propertyLocation={
          selectedRunner?.PropertyData.coordinates ||
          property?.coordinatesCenter ||
          null
        }
      />
      <SidebarResults
        selectedRunner={selectedRunner}
        setSelectedRunner={setSelectedRunnerHandler}
        selectedResult={selectedResult}
        setSelectedResult={setSelectedResultHandler}
      />
      {selectedResult && (
        <SidebarResultsRight
          selectedBuilding={selectedBuilding}
          selectedResult={selectedResult}
          propertyArea={selectedRunner?.PropertyData?.area}
          showGrid={showGrid}
          setShowGrid={setShowGrid}
          getSelectedGridIndex={getSelectedGridIndex}
          setSelectedGridIndex={setSelectedGridIndex}
        />
      )}
      {propertyGeoData && (
        <PropertyLayer
          selectedRunner={selectedRunner}
          runnerPropertyData={selectedRunner?.PropertyData}
          displayDimensions={displayDimensions}
        />
      )}
      {selectedResult && (
        <BuildingLayer
          projectId={projectId}
          selectedResult={selectedResult}
          buildings={selectedResult.buildings}
          selectedBuilding={selectedBuilding}
          setSelectedBuilding={setSelectedBuilding}
          routes={selectedResult.routes}
          showGrid={showGrid}
          getSelectedGridIndex={getSelectedGridIndex}
        />
      )}
    </>
  );
};
